import { ITransferCoursesDatasource } from './../datasources/transfer_courses_datasource';
import { ITransferMajorsDatasource } from './../datasources/transfer_majors_datasource';
import { Major } from './../builders/major_builder';
import { ICommand, IDefineCommand, IDatasource, IQueryMediator, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IProgression } from 'utility-js-progression';
import { SelectionListServant } from '../../global/servants/selection_list_servant';
import { TransferTransactionModel } from '../models/transfer_transaction_model';

angular.module('capability-ng-transfer').factory(
  'selectTransferMajorCommand',
  (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngTransferCreditsProgression: IProgression,
    ngTransferMajorsDatasource: ITransferMajorsDatasource,
    ngSelectionListServant: SelectionListServant,
    ngTransferCoursesDatasource: ITransferCoursesDatasource,
    $http: ng.IHttpService,
    ngTransferMajorTransactionModel: TransferTransactionModel,
    log: any,
    loadTransferMajorDegreeAuditCommand: ICommand
  ): ICommand => {
    return defineCommand('selectTransferMajorCommand', function selectMajor(
      deferred: ng.IDeferred<IQuery[]>,
      major: Major
    ): void {
      const isAlreadySelected = _4.get(ngTransferMajorsDatasource.get(major.id) as Major, 'isSelected', false);
      const isAlreadyProcessed = ngTransferMajorTransactionModel.ids.has(major.id) || isAlreadySelected;

      const hasCrossedMaxMajors = ngSelectionListServant.isFull(ngTransferMajorsDatasource.model.majorsSelection);
      if (hasCrossedMaxMajors) {
        const timeout = 4000;
        log.user.warn({
          content: `You already have selected ${ngTransferMajorsDatasource.model.majorsSelection.maximum} majors. Please remove a major to make a different selection.`,
          timeout
        });
      }

      if (!major || isAlreadyProcessed || hasCrossedMaxMajors) {
        return deferred.resolve(QueryMediator.runQueries());
      }

      ngTransferMajorTransactionModel.ids.add(major.id);

      $http({
        method: 'POST',
        url: `student/program/`,
        data: {
          program: major.id
        }
      })
        .then((response: ng.IHttpPromiseCallbackArg<any>): void => {
          ngTransferMajorsDatasource.put(_.merge(major, { created_ts: response.data.results.created_ts }));
          const selectedMajor = ngTransferMajorsDatasource.get(major.id);
          ngSelectionListServant.select(ngTransferMajorsDatasource.model.majorsSelection, selectedMajor!);
          if (!_.isEmpty(ngTransferCoursesDatasource.read()) && !selectedMajor!.preprof_ind) {
            loadTransferMajorDegreeAuditCommand(selectedMajor!.id);
          }

          deferred.resolve(QueryMediator.runQueries(ngTransferMajorsDatasource));
        })
        .catch(deferred.reject)
        .finally(() => ngTransferMajorTransactionModel.ids.delete(major.id));
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/select_transfer_major_command.ts